import { render } from "./AppNotify.vue?vue&type=template&id=9d35181e&scoped=true"
import script from "./AppNotify.vue?vue&type=script&lang=js"
export * from "./AppNotify.vue?vue&type=script&lang=js"

import "./AppNotify.vue?vue&type=style&index=0&id=9d35181e&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d35181e"]])

export default __exports__